export const numberInventory = [
    {
        phoneNumber: "6042605190",
        numberCountryName: "Canada",
        userName: "",
        departmentId: "",
        numberTypeId: "",
        carrierId: "",
        streetAddress1: "",
        streetAddress2: "",
        city: "",
        state: "",
        country: "",
        postalCode: "",
        numberNotes: "For CEO",
        manageStatus: "Unmanaged",
        classification: "",
        assignStatus: "Unassigned",
        reserveStatus: "Reserved"
    },
    {
        phoneNumber: "2037443261",
        numberCountryName: "United Kingdom",
        userName: "User1",
        departmentId: "",
        numberTypeId: "",
        carrierId: "",
        streetAddress1: "",
        streetAddress2: "",
        city: "",
        state: "",
        country: "",
        postalCode: "",
        numberNotes: "",
        manageStatus: "Unmanaged",
        classification: "",
        assignStatus: "Assigned",
        reserveStatus: "Unreserved",
    },
    {
        phoneNumber: "2037443299",
        numberCountryName: "United Kingdom",
        userName: "User2",
        departmentId: "",
        numberTypeId: "",
        carrierId: "",
        streetAddress1: "",
        streetAddress2: "",
        city: "",
        state: "",
        country: "",
        postalCode: "",
        numberNotes: "",
        manageStatus: "Unmanaged",
        classification: "",
        assignStatus: "Assigned",
        reserveStatus: "Unreserved",
    },
    {
        phoneNumber: "2406856580",
        numberCountryName: "United States",
        userName: "",
        departmentId: "",
        numberTypeId: "",
        carrierId: "",
        streetAddress1: "",
        streetAddress2: "",
        city: "",
        state: "",
        country: "",
        postalCode: "",
        numberNotes: "",
        manageStatus: "Managed",
        classification: "Production",
        assignStatus: "Unassigned",
        reserveStatus: "Reserved",
    },
    {
        phoneNumber: "4109190300",
        numberCountryName: "United States",
        userName: "",
        departmentId: "",
        numberTypeId: "",
        carrierId: "",
        streetAddress1: "",
        streetAddress2: "",
        city: "",
        state: "",
        country: "",
        postalCode: "",
        numberNotes: "",
        manageStatus: "Managed",
        classification: "Production",
        assignStatus: "Unassigned",
        reserveStatus: "Unreserved",
    }
]

export const numberDevices = [
    {
        numberCountryName: "Canada",
        phoneNumber: "6042605190",
        makeName: "Yealink",
        modelName: "MSpeech",
        deviceTypeName: "Accessory",
        serialNumber: "SN123"
    },
    {
        numberCountryName: "Canada",
        phoneNumber: "6042605190",
        makeName: "AudioCodes",
        modelName: "C435HD",
        deviceTypeName: "Desk Phone",
        serialNumber: ""
    },
    {
        numberCountryName: "United Kingdom",
        phoneNumber: "2037443261",
        makeName: "Jabra",
        modelName: "Biz 2300 duo",
        deviceTypeName: "HeadSet",
        serialNumber: "SN777"
    },
    {
        numberCountryName: "United Kingdom",
        phoneNumber: "2037443261",
        makeName: "Microsoft",
        modelName: "Modern USB-C Speaker",
        deviceTypeName: "Speakerphone",
        serialNumber: "SN123"
    },
    {
        numberCountryName: "United Kingdom",
        phoneNumber: "2037443261",
        makeName: "Yealink",
        modelName: "",
        deviceTypeName: "Web Camera",
        serialNumber: ""
    },
]